import { render, staticRenderFns } from "./AppIndex.vue?vue&type=template&id=5065328f&scoped=true&"
import script from "./AppIndex.vue?vue&type=script&lang=js&"
export * from "./AppIndex.vue?vue&type=script&lang=js&"
import style0 from "./AppIndex.vue?vue&type=style&index=0&id=5065328f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5065328f",
  null
  
)

export default component.exports